/* tslint:disable */

import { CMSResource } from "app/resources/cmsresource";
import { AppointmentResource } from "./AppointmentResource";




export class CMSListResourceSupport extends CMSResource {

	numberOfPages: number;

}
